export default class Ytb {
  constructor(element) {
    this.element = element;
    this.id = this.getVideoId();

    if (!this.id) {
      return;
    }

    this.init();
  }

  init() {
    this.element.classList.add('ytb');
    this.setRatio();
    this.element.innerHTML = '';
    this.element.appendChild(this.createIframe());
  }

  getVideoId() {
    const id = this.element.dataset.ytbId;

    if (id) {
      return id;
    }

    return this.getVideoIdFromUrl(this.element.dataset.ytbUrl || '');
  }

  getVideoIdFromUrl(url) {
    if (!url) {
      return '';
    }

    try {
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname.replace('www.', '');

      if (hostname === 'youtu.be') {
        return parsedUrl.pathname.split('/').filter(Boolean)[0] || '';
      }

      if (hostname.includes('youtube.com')) {
        if (parsedUrl.searchParams.get('v')) {
          return parsedUrl.searchParams.get('v');
        }

        const parts = parsedUrl.pathname.split('/').filter(Boolean);
        const embedIndex = parts.findIndex((part) => ['embed', 'shorts'].includes(part));

        if (embedIndex !== -1) {
          return parts[embedIndex + 1] || '';
        }
      }
    } catch (error) {
      return url;
    }

    return '';
  }

  setRatio() {
    const ratio = this.element.dataset.ytbRatio;

    if (ratio) {
      this.element.style.setProperty('--ytb-ratio', ratio);
    }
  }

  createIframe() {
    const iframe = document.createElement('iframe');
    const allowFullscreen = this.getBoolean('ytbFullscreen', true);

    iframe.className = 'ytb__iframe';
    iframe.src = this.getSrc();
    iframe.title = this.element.dataset.ytbTitle || 'Video YouTube';
    iframe.loading = this.element.dataset.ytbLoading || 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allow = this.getAllow();

    if (allowFullscreen) {
      iframe.allowFullscreen = true;
    }

    return iframe;
  }

  getSrc() {
    const domain = this.getBoolean('ytbCookieFree', false) ? 'https://www.youtube-nocookie.com' : 'https://www.youtube.com';
    const params = this.getParams();

    return `${domain}/embed/${this.id}?${params.toString()}`;
  }

  getParams() {
    const params = new URLSearchParams();

    params.set('controls', this.getBoolean('ytbControls', true) ? '1' : '0');
    params.set('rel', this.getBoolean('ytbRelated', true) ? '1' : '0');
    params.set('fs', this.getBoolean('ytbFullscreen', true) ? '1' : '0');
    params.set('disablekb', this.getBoolean('ytbKeyboard', true) ? '0' : '1');
    params.set('playsinline', this.getBoolean('ytbInline', true) ? '1' : '0');
    params.set('cc_load_policy', this.getBoolean('ytbCaptions', false) ? '1' : '0');
    params.set('iv_load_policy', this.getBoolean('ytbAnnotations', false) ? '1' : '3');

    if (!this.getBoolean('ytbBranding', true)) {
      params.set('modestbranding', '1');
    }

    if (this.getBoolean('ytbAutoplay', false)) {
      params.set('autoplay', '1');
      params.set('mute', '1');
    }

    if (this.getBoolean('ytbMuted', false)) {
      params.set('mute', '1');
    }

    if (this.getBoolean('ytbLoop', false)) {
      params.set('loop', '1');
      params.set('playlist', this.id);
    }

    this.setNumberParam(params, 'start', this.element.dataset.ytbStart);
    this.setNumberParam(params, 'end', this.element.dataset.ytbEnd);

    return params;
  }

  setNumberParam(params, key, value) {
    const number = Number.parseInt(value, 10);

    if (Number.isFinite(number) && number >= 0) {
      params.set(key, number.toString());
    }
  }

  getAllow() {
    const allow = ['accelerometer', 'clipboard-write', 'encrypted-media', 'gyroscope', 'picture-in-picture', 'web-share'];

    if (this.getBoolean('ytbAutoplay', false)) {
      allow.unshift('autoplay');
    }

    return allow.join('; ');
  }

  getBoolean(key, defaultValue) {
    if (!Object.prototype.hasOwnProperty.call(this.element.dataset, key)) {
      return defaultValue;
    }

    return !['false', '0', 'no', 'non'].includes(this.element.dataset[key].toLowerCase());
  }
}
